const getters = {
  yd_product_id: (state) => state.info.yd_product_id,
  login_ways: (state) => state.info.login_ways,
  google_config: (state) => state.info.google_config,
  captcha_id: (state) => state.info.captcha_id,
};
export default getters;
